import { useContext } from "react";
import { Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { BoxFull, Dropdown, InputText, InputTextarea, Calendar } from "iuvity-ui-components";
import { AppContext } from "../../context/index";
import { PhoneNumberInput } from "iuvity-ui-components/dist/phonenumberinput"

interface CustomFormBoxProps {
    fields: any;
    disabledFieldsObject?: any;
    isOptional?: any;
    form: any;
    dropdownOptions?: any;
    boxTitle?: string;
    updateMultiple?: boolean;
    schemaOfValidation: (t:Function)=>{};
    language?: string;
    calendarTranslations?: any;
    calendarOptions?: any;
    setCalendarOptions?: Function;
    REVALIDATE_FORM_PROPS?: any;
    readOnlyObject?: any;
    labelFunctionality?: string;
    dropdownShowClearObject?: any;
  }

export const CustomFormBox: React.FC<CustomFormBoxProps> = ({
    fields,
    disabledFieldsObject,
    form,
    dropdownOptions=[],
    boxTitle,
    updateMultiple,
    isOptional,
    schemaOfValidation,
    language='en',
    calendarTranslations={},
    calendarOptions,
    setCalendarOptions,
    REVALIDATE_FORM_PROPS,
    readOnlyObject,
    labelFunctionality='PointsOfAttention',
    dropdownShowClearObject,
  }) => {
const {
    t,
    appState: { user },
    } = useContext(AppContext);

    const {
        control,
        getValues,
        setValue,
        formState: { errors },
    } = form;

    return (
        <div className="custom-form-box-container mt-4">
            {
                boxTitle ?
                <div className="flex justify-content-center pl-8">
                    <p
                        className="boxTitle pl-5"
                        style={{
                            marginLeft: 'var(--space-xxl)',
                            width: '80rem'}}>
                        {boxTitle}
                    </p>
                </div> :
                null
            }
            <BoxFull className={`dt-c mt-4 pt-5 pb-2 px-5 ${updateMultiple === true ? "" : "fields-main-container"}`} style={{ backgroundColor: 'var(--cardBackgroundColorTwo)' }}>
                <div className="flex align-items-flex-start justify-content-flex-start flex-wrap fields-box">
                {Object.keys(getValues()).length > 0 && (
                    <>
                    {fields?.map((property: any) => {
                        const newKey = property.key.split(".").pop();
                        return (
                        <div
                            key={`c-${property.key}`}
                            className="flex flex-column mb-4"
                            style={{ width: "40%" }}
                        >
                            <Controller
                                key={newKey}
                                name={newKey}
                                control={control}
                                rules={(schemaOfValidation(t) as any)[newKey]}
                                render={({ field }) => {
                                    let extraProps = {
                                    keyfilter: (schemaOfValidation(t) as any)[newKey]
                                        ?.keyfilter,
                                    maxLength: (schemaOfValidation(t) as any)[newKey]
                                        ?.maxLength?.value,
                                    };
                                    // Uso del field.onChange solo en Calendar porque no es reactivo en campos dependientes
                                    if (property.type === 'calendar') {
                                        field.onChange = (e)=>{
                                            setValue(
                                                field.name,
                                                property.type === 'phone' ? e : e.target.value,
                                                REVALIDATE_FORM_PROPS
                                            );
                                            if (setCalendarOptions && newKey === 'startDate') {
                                                setValue('endDate', '', REVALIDATE_FORM_PROPS)
                                                setCalendarOptions((prev:any)=>({
                                                    ...prev,
                                                    endDate: {
                                                        ...prev.endDate,
                                                        minDate: e.target.value,
                                                        disabled: false,
                                                    }
                                                }))
                                            }
                                        };
                                    }
                                    return (
                                        property.type === 'dropdown' ?
                                            <Dropdown
                                                key={newKey}
                                                id={`input-${newKey}`}
                                                className="dropdown"
                                                label={t(`${labelFunctionality}.${newKey === 'pointServiceType' ? 'typeOfPointAttention' : newKey}Label`)}
                                                placeholder={t(`${labelFunctionality}.${newKey}Placeholder`)}
                                                style={{ width: "100%", maxWidth: "var(--inputMaxWidth)" }}
                                                options={dropdownOptions[newKey]}
                                                showClear={dropdownShowClearObject ? dropdownShowClearObject[newKey] : false}
                                                {...field}
                                                readOnly={readOnlyObject ? readOnlyObject[newKey] : false}
                                                disabled={
                                                    (disabledFieldsObject && disabledFieldsObject.hasOwnProperty(newKey))
                                                    ? disabledFieldsObject[newKey]
                                                    : false}
                                            /> :
                                        property.type === 'textarea' ?
                                            <InputTextarea
                                                id={`input-${newKey}`}
                                                key={newKey}
                                                className={`${
                                                (errors as any)[newKey]?.message
                                                    ? "p-invalid"
                                                    : "input-md"
                                                }`}
                                                label={t(`${labelFunctionality}.${newKey}Label`)}
                                                placeholder={t(`${labelFunctionality}.${newKey}Placeholder`)}
                                                autoComplete="off"
                                                autoResize={true}
                                                rows={4}
                                                cols={30}
                                                style={{
                                                width: "20rem",
                                                minHeight: "80px",
                                                maxHeight: "80px",
                                                }}
                                                {...field}
                                                {...extraProps}
                                            /> :
                                        property.type === 'phone' ?
                                            <PhoneNumberInput
                                                country = 'co'
                                                localization={language}
                                                label={t(`${labelFunctionality}.${newKey}Label`)}
                                                placeholder={t(`${labelFunctionality}.${newKey}Placeholder`)}
                                                searchPlaceholder={t("TableHeader.searchPlacehoder")}
                                                preferredCountries={['co', 'ec']}
                                                {...field}
                                            />
                                            :
                                        property.type === 'calendar' ?
                                            <Calendar
                                                id={`input-${newKey}`}
                                                key={newKey}
                                                label={t(`${labelFunctionality}.${newKey}Label`)}
                                                isOptional={isOptional[newKey]}
                                                optionText={t(`${labelFunctionality}.optionalLabel`)}
                                                placeholder={language === 'es' ? "DD/MM/YYYY" : "MM/DD/YYYY"}
                                                dateFormat={ language === 'es' ? "dd/mm/yy" : "mm/dd/yy"}
                                                locale={language}
                                                translations={calendarTranslations}
                                                minDate={calendarOptions[newKey]['minDate']}
                                                isDisable={calendarOptions[newKey]['disabled']}
                                                {...field}
                                            /> :
                                        <InputText
                                            id={`input-${newKey}`}
                                            key={newKey}
                                            className={`${
                                            (errors as any)[newKey]?.message
                                                ? "p-invalid"
                                                : "input-md mt-2"
                                            }`}
                                            label={t(`${labelFunctionality}.${newKey}Label`)}
                                            placeholder={t(`${labelFunctionality}.${newKey}Placeholder`)}
                                            type={
                                            property.type === "number" ? "text" : property.type
                                            }
                                            autoComplete="off"
                                            style={{
                                            width: "20rem",
                                            }}
                                            isReadOnly={readOnlyObject ? readOnlyObject[newKey] : false}
                                            {...field}
                                            {...extraProps}
                                        /> 
                                    );
                                }}
                            />
                            {property.type !== "boolean" && (
                                <ErrorMessage
                                    key={`err-${newKey}`}
                                    errors={errors}
                                    name={newKey}
                                    //@ts-ignore
                                    render={({ message }) => (
                                    <small
                                        className="p-error block"
                                        style={{
                                        marginTop: "0.5rem",
                                        marginBottom: "1.5rem",
                                        }}
                                    >
                                        {message}
                                    </small>
                                    )}
                                />
                            )}
                        </div>
                        );
                    })}
                    </>
                )}
                </div>
            </BoxFull>
        </div>
    );
  }
